import React from 'react';
import PropTypes from 'prop-types';
import PanelSection from 'components/v2/PanelSection';
import Button from 'components/v2/buttons/Button';
import classnames from 'classnames';
import LoadingCircle from 'components/ui/LoadingCircle';

export default function CardFooter({
  children,
  actionLabel,
  cancelLabel,
  className,
  onActionClick,
  onCancelClick,
  showCancelButton,
  cancelLink,
  otherActions,
  disabled = false,
  showSpinner = false,
  actionTestDataId,
  cancelTestDataId,
}) {
  return (
    <PanelSection className={classnames(className, 'bg-gray-50')}>
      <div className="flex items-center justify-end">
        {children}
        <div className="flex items-center justify-end space-x-4">
          <Button
            color="green"
            onClick={onActionClick}
            disabled={disabled}
            className="flex items-center"
            testDataId={actionTestDataId}
          >
            {showSpinner && <LoadingCircle color="white" />}
            {actionLabel}
          </Button>
          {otherActions && otherActions()}
          {showCancelButton && onCancelClick && (
            <Button
              color=""
              onClick={onCancelClick}
              disabled={disabled}
              testDataId={cancelTestDataId}
            >
              {cancelLabel}
            </Button>
          )}
          {showCancelButton && cancelLink && (
            <Button
              color=""
              href={cancelLink}
              disabled={disabled}
              testDataId={cancelTestDataId}
            >
              {cancelLabel}
            </Button>
          )}
        </div>
      </div>
    </PanelSection>
  );
}

CardFooter.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  actionLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  onActionClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  showCancelButton: PropTypes.bool,
  cancelLink: PropTypes.string,
  otherActions: PropTypes.func,
  actionTestDataId: PropTypes.string,
  cancelTestDataId: PropTypes.string,
};

CardFooter.defaultProps = {
  actionLabel: 'Save',
  cancelLabel: 'Cancel',
  showCancelButton: true,
};
